import { Box, InputAdornment, TextField, Typography } from "@mui/material";
import { ColorScheme } from "../../Themes/ColorScheme";
import TooltipWrapper from "./TooltipWrapper";

let style = {
	// saved from local component level styling to here⁄
	display: "flex",
	flexDirection: "row",
	alignItems: "center",
	borderRadius: "4px",
	width: "100%",
	height: "100%",
	minHeight: "75px",
	maxHeight: "75px",
	backgroundColor: ColorScheme.lightGrey,
	marginBottom: "10px", // todo fix this, remove (10px) and use gap property in parent
	alignSelf: "center",
	boxSizing: "border-box",
	border: "1px solid " + ColorScheme.darkGrey + ColorScheme.opacity25,
	overflow: "hidden",
	icon: {
		height: "40px",
		minHeight: "40px",
		maxHeight: "40px",
		width: "40px",
		minWidth: "40px",
		maxWidth: "40px",
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		boxSizing: "border-box",
		marginLeft: "20px",
		cursor: "pointer"
	},
	inputHeader: {
		// not in use
		fontSize: "12px",
		color: ColorScheme.primary,
		fontWeight: "700",
		marginTop: 0
	},

	select: {
		// not in use
		minHeight: "50px",
		backgroundColor: ColorScheme.lightGrey,
		height: undefined,
		"& .MuiOutlinedInput-root": {
			position: "relative",
			// top: "7px",
			backgroundColor: "inherit"
		},

		"fieldset.MuiOutlinedInput-notchedOutline": {
			border: "none"
		},
		"& .MuiFormLabel-root": {
			top: "0px",
			transition: "all 0.2s ease-in-out" // slower animation transition
		},
		"&.Mui-focused": {
			color: ColorScheme.black,
			top: "2px"
		},
		"& .MuiInputLabel-root.Mui-focused": {
			/* color: ColorScheme.black, */
			top: "10px"
		},
		"& .Mui-active": {
			color: ColorScheme.black
		},
		"& .MuiSelect-icon": {
			/* top: "5px", */
			transition: "all 0.2s ease-in-out" // slower animation transition
		}
	},

	pickers: {
		width: "100%",
		height: "100%",
		backgroundColor: ColorScheme.lightGrey,
		minHeight: "75px",
		"& .MuiInputBase-root": {
			// should cover TextField with select property
			minHeight: "55px",
			backgroundColor: ColorScheme.lightGrey,
			"fieldset.MuiOutlinedInput-notchedOutline": {
				border: "none"
			}
		},
		"& .MuiOutlinedInput-root": {
			minHeight: "75px",
			backgroundColor: "inherit",
			position: "relative",
			top: "7px"
		},
		"& .MuiOutlinedInput-notchedOutline": {
			border: "none"
		},
		fieldset: {
			border: "none"
		},
		label: {
			fontSize: "14px",
			top: "28px"
		}
	},

	"& .MuiInputBaseRoot": {
		// should cover TextField with select property
		minHeight: "55px",
		backgroundColor: ColorScheme.lightGrey,
		"fieldset.MuiOutlinedInput-notchedOutline": {
			border: "none"
		}
	},
	"& .MuiOutlinedInput-notchedOutline": {
		border: 0
	}
};


export const TextFieldInput = ({
	text, // selected value
	valueChange, // function to change value (onChange)
	title, // if input is empty this will be the placeholder, if not it will be the label above the input
	rowAmount, // if defined, input will be multiline. <<--- needs to be refactored to be boolean instead of value
	hasProps, // icon or other element for input field
	hasCharLimit, // if defined (number), input will have a character limit
	charCount, // if defined (boolean), input will show character count
	isRequired, // if defined (boolean), input will be required
	checkValue, // if defined (boolean), input will be checked for validity
	defaultText,
	helpText,
	removeIcon,
	endAdornment,
	onlyEmail,
	handleManualAction,
	validateManualAction,
	enableManualAction,
	maxNumberValue
}) => {
	const handleInputChange = (input) => {
		const value = input.target.value;
		valueChange(value);
	};

	const validateEmail = (email) => {
		const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
		return emailRegex.test(email);
	};

	const validateUserInput = (id) => {
		const internationalRegex = /^\+(?:[0-9]?){1,4}[0-9]{9,14}(?:x.+)?$/; // intl phone numbers with required country code
		const finnishRegex =
			/^(?:\+358|0)(?:\s|-)?\d{1,3}(?:\s|-)?\d{4,}(?:\s|-)?\d{0,2}$/; // finnish numbers with and without country code prefix

		const phoneIsValid =
			internationalRegex.test(id) || finnishRegex.test(id);

		const emailIsValid = validateEmail(id);

		const allDigitsAreSame = /^(\d)\1+$/.test(id); // prevent lazy inputs like 0000000

		return (phoneIsValid || emailIsValid) && !allDigitsAreSame;
	};

	const checkValidity = (id) =>
		onlyEmail ? !validateEmail(id) : !validateUserInput(id);

	return (
		<Box
			style={{
				...style,
				...(rowAmount !== undefined && {
					maxHeight: undefined, // let parent box dynamically handle height as needed in multirow mode
					position: "relative"
				})
			}}
		>
			{!removeIcon && (
				<Box
					style={{
						...style.icon,
						...(rowAmount !== undefined && {
							// aligns icon to top if multiline
							// ToDo: fix scaling (especially for 10+ rows)
							display: "flex",
							flexWrap: "wrap",
							/* minHeight: "100%",
							height: "100%",  `calc(2px * ${text.length / 8})`, 
							maxHeight: "100%", */
							alignItems: "normal",
							/* position: "fixed", */
							height: undefined,
							minHeight: undefined,
							position: "absolute",
							top: "30px"
							/* left: "10px", */
						})
					}}
				>
					<TooltipWrapper title={helpText}>{hasProps}</TooltipWrapper>
				</Box>
			)}

			<TextField
				variant="filled"
				label={title}
				placeholder={defaultText}
				multiline={rowAmount !== undefined ? true : false}
				/* rows={rowAmount !== undefined && rowAmount} */
				error={checkValue || maxNumberValue < Number(text)}
				required={isRequired}
				helperText={
					charCount &&
					hasCharLimit !== undefined &&
					`${text?.length || "0"} / ${hasCharLimit}`
				}
				inputProps={hasCharLimit && { maxLength: hasCharLimit }}
				sx={{
					width: "100%",
					/* height: `${rowAmount !== undefined ? `calc(28px * ${rowAmount})` : "auto"}`, */
					alignItems: "end", // aligns helpertext to right if it exists
					...(rowAmount !== undefined && {
						position: "relative",
						marginLeft: "62px",
						marginTop: "10px"
					}),
				}}
				InputProps={{
					disableUnderline: true,
					style: {
						width: "100%",
						color: ColorScheme.black,
						backgroundColor: ColorScheme.transparent,
						borderRadius: "20px",
						border: "0px solid " + ColorScheme.transparent,
						fontSize: "15px"
					},
					endAdornment: (
						<InputAdornment
							position="end"
							sx={{ paddingRight: "5px" }}
						>
							<Typography fontSize={14} color={ColorScheme.black}>
								{endAdornment}
							</Typography>
						</InputAdornment>
					)
				}}
				InputLabelProps={{
					style: {
						fontSize: "14px",
						top: /* rowAmount !== undefined ? "5px" : */ "3px"
					}
				}}
				value={text}
				onChange={handleInputChange}
				onKeyDown={(e) => {
					if (enableManualAction) return; // prevent enter key from triggering handleAnotherUser if input is invalid
					if (validateManualAction && e.key === "Enter")
						if (checkValidity(e.target.value)) handleManualAction();
				}}
			/>
		</Box>
	);
};
